var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBillingW(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6116_241791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5234 9V9.4V28.6V29H10.9282H27.1186H27.5234V28.6V9.4V9H27.1186H10.9282H10.5234ZM11.333 9.8H26.7139V28.2H11.333V9.8Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.166 14.2004V13.4004H23.8803V14.2004H14.166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.166 19.8004V19.0004H19.8327V19.8004H14.166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8565 19.8004V19.0004H23.8803V19.8004H21.8565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.166 22.2004V21.4004H19.8327V22.2004H14.166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8565 22.2004V21.4004H23.8803V22.2004H21.8565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.166 24.6004V23.8004H19.8327V24.6004H14.166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8565 24.6004V23.8004H23.8803V24.6004H21.8565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.166 14.2004V13.4004H23.8803V14.2004H14.166Z",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.166 19.8004V19.0004H19.8327V19.8004H14.166Z",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8565 19.8004V19.0004H23.8803V19.8004H21.8565Z",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.166 22.2004V21.4004H19.8327V22.2004H14.166Z",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8565 22.2004V21.4004H23.8803V22.2004H21.8565Z",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.166 24.6004V23.8004H19.8327V24.6004H14.166Z",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8565 24.6004V23.8004H23.8803V24.6004H21.8565Z",
    stroke: "white",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6116_241791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 20,
    fill: "white",
    transform: "translate(10.5234 9)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingW);
export default __webpack_public_path__ + "static/media/billing-w.3f5068fe64b3c04545fd0484d09bdcfb.svg";
export { ForwardRef as ReactComponent };